import React, { FC, useCallback } from 'react'
import styles from 'styles/components/template.module.scss'
import { Spacer } from 'components/Utility'
import { FlexColumn } from 'components/Flex'
import text from 'styles/utility/text.module.scss'
import { BlueButton, NavButton } from 'components/Button'
import { useDispatch } from 'react-redux'
import { push } from 'connected-react-router'
import { initBreads } from 'reducks/bread/operations'
import { initStocks } from 'reducks/stock/operations'
import { initSchedules } from 'reducks/schedule/operations'
import { initStoreDeliveryBread } from 'reducks/storeDeliveryBread/operations'

const ProductEditCompleteTemplate: FC = () => {
  const dispatch = useDispatch()

  const createNextProduct = useCallback(() => {
    dispatch(initBreads())
    dispatch(initStoreDeliveryBread())
    dispatch(initStocks())
    dispatch(initSchedules())
    dispatch(push('/product/create'))
  }, [dispatch])

  return (
    <div className={styles.standard}>
      <Spacer size={48} />
      <FlexColumn alignItems={'center'}>
        <img src={'/icon/done/product.svg'} alt={'出品する商品の登録が完了しました'} />
        <Spacer size={16} />
        <h2 className={`${text.font_xxxlarge} ${text.align_center}`}>
          出品する商品の登録が
          <br />
          完了しました
        </h2>
      </FlexColumn>
      <Spacer size={48} />
      <BlueButton
        endIconPath={'/icon/white/arrow_next_small.svg'}
        label={'引続き商品の登録を行う'}
        onClick={createNextProduct}
        size={'medium'}
        type={'main'}
      />
      <Spacer size={12} />
      <NavButton label={'sacriで出品する商品の一覧に戻る'} iconPath={'/icon/grey/arrow_prev.svg'} url={'/product'} />
      <Spacer size={72} />
    </div>
  )
}

export default ProductEditCompleteTemplate
